// import React, { useState, useEffect } from 'react';
// import { useSnackbar } from 'notistack';

// const Test = () => {
//   const [reload, setReload] = useState(false);
//   const [color, setColor] = useState('blue');
//   const [speed, setSpeed] = useState(2000);
//   const [size, setSize] = useState(10)
//   const [visible, setVisible] = useState(true)
//   const loadStart = () => {
//     if (visible) {

//  try {
//     console.log('1st',document.getElementById('').style);

//     document.getElementById(`1st`).style.background = 'blue';
//     document.getElementById(`1st`).style.transition = 'all 0.5s ease';

//     setTimeout(function() {
//       console.log('2nd');
//       document.getElementById(`1st`).style.background = 'none';
//       document.getElementById(`1st`).style.transition = 'all 0.5s ease';

//       document.getElementById(`2nd`).style.background = 'blue';
//       document.getElementById(`2nd`).style.transition = 'all 0.5s ease';
//     }, speed);
//     setTimeout(function() {
//       console.log('3nd');
//       document.getElementById(`2nd`).style.background = 'none';
//       document.getElementById(`2nd`).style.transition = 'all 0.5s ease';

//       document.getElementById(`3rd`).style.background = 'blue';
//       document.getElementById(`3rd`).style.transition = 'all 0.5s ease';
//     }, speed * 2);

//     setTimeout(function() {
//       document.getElementById(`3rd`).style.background = 'none';
//       document.getElementById(`3rd`).style.transition = 'all 0.5s ease';

//       document.getElementById(`4th`).style.background = 'blue';
//       document.getElementById(`4th`).style.transition = 'all 0.5s ease';
//     }, speed * 3);
//     setTimeout(function() {
//       console.log('4th');
//       document.getElementById(`4th`).style.background = 'none';
//       document.getElementById(`4th`).style.transition = 'all 0.5s ease';
//       setReload(!reload);
//     }, speed * 4);
//   } catch (error) {
//    console.log('error11111',error);
//   }
// }else{
//   console.log('else');
// }
//   };

//   useEffect(() => {
//     if (visible) {
//       console.log('visible',visible);
//       loadStart();
//     }
//   }, [reload]);
//   return (
//     <div>
//       <button onClick={()=>{setVisible(!visible)}}>Stop</button>
//       <div style={{ display: 'flex' }}>
//         <div
//           id="1st"
//           style={{
//             background: 'none',
//             border: `1px solid ${color}`,
//             height: `${size}px`,
//             width: `${size}px`,
//             borderRadius: '50%',
//             margin: '0 5px',
//           }}></div>
//         <div
//           id="2nd"
//           style={{
//             background: 'none',
//             border: `1px solid ${color}`,
//             height: `${size}px`,
//             width: `${size}px`,
//             borderRadius: '50%',
//             margin: '0 5px',
//           }}></div>
//         <div
//           id="3rd"
//           style={{
//             background: 'none',
//             border: `1px solid ${color}`,
//             height: `${size}px`,
//             width: `${size}px`,
//             borderRadius: '50%',
//             margin: '0 5px',
//           }}></div>
//         <div
//           id="4th"
//           style={{
//             background: 'none',
//             border: `1px solid ${color}`,
//             height: `${size}px`,
//             width: `${size}px`,
//             borderRadius: '50%',
//             margin: '0 5px',
//           }}></div>
//       </div>
//       <button onClick={loadStart}>Start</button>
//     </div>
//   );
// };

// export default Test;
import React from 'react';

const Test = () => {
  const myArray = [5, 15, 12, 55];

  const check = () => {
    // console.log('11111111');
    for (let index = 0; index < myArray.length; index++) {
      const element = myArray[index];

      let checkElement = myArray[index + 1];

      // console.log('element',element,preElement,supElement,checkElement);
      // console.log('index', index);
      if (checkElement === element || checkElement === element - 1 || checkElement === element + 1) {
        return console.log('pin not ok');
      }
    }
  };
  return (
    <div>
      <button onClick={check}>Check</button>
    </div>
  );
};

export default Test;
